<template>
  <button
    v-title="title"
    :id="id"
    :type="type"
    :class="btnClass"
    @click="click()"
    @submit="submit()"
    :disabled="isLoading || disabled"
  >
    <i
      v-if="!iconRight && icon && !isLoading"
      class="btn-icon"
      :class="[!!text ? 'mr-2' : '', 'fa', `fa-${icon}`]"
    ></i>

    <span
      :class="{'mr-2': !!text}"
      class="spinner-border spinner-border-sm"
      v-if="isLoading"
      role="status"
      aria-hidden="true"
    ></span>

    <span v-if="text && translateText">{{ $t(text) }}</span>
    <span v-else-if="text">{{ text }}</span>

    <i
      v-if="iconRight && icon && !isLoading"
      class="btn-icon"
      :class="[!!text ? 'ml-2' : '', 'fa', `fa-${icon}`]"
    ></i>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    block: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    icon: {
      type: String,
    },
    iconRight: {
      type: Boolean,
      default() {
        return false;
      },
    },
    id: {
      type: String,
      required: false,
    },
    loader: {
      type: Object,
      default() {
        return {
          auto: false,
          loading: false,
        };
      },
    },
    noPadding: {
      type: Boolean,
      default() {
        return false;
      },
    },
    rounded: {
      type: Boolean,
      default() {
        return false;
      },
    },
    routeTo: {
      type: Object,
    },
    styleType: {
      type: String,
      default() {
        return 'primary';
      },
    },
    size: {
      default() {
        return 'md';
      },
    },
    text: {
      type: String,
    },
    title: {
      type: String,
      default() {
        return '';
      },
    },
    translateText: {
      default() {
        return true;
      },
    },
    type: {
      type: String,
      default() {
        return 'button';
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isLoading() {
      return this.loader.loading || this.loading;
    },
    btnClass() {
      return [
        'btn',
        `btn-${this.styleType}`,
        this.block ? 'btn-block' : '',
        `btn-${this.size}`,
        this.rounded ? 'rounded-pill' : '',
        this.noPadding ? 'no-padding' : '',
      ];
    },
  },
  methods: {
    click() {
      if (this.loader.auto) {
        this.loading = true;
      }
      if (this.routeTo) {
        this.$router.push(this.routeTo);
      } else {
        this.$emit('click');
      }
    },
    submit() {
      if (this.loader.auto) {
        this.loading = true;
      }
      this.$emit('submit');
    },
  },
};
</script>

<style scoped>
.btn-link {
  box-shadow: 0 1px 0 rgba(0, 0, 0, .0);
}

.no-padding {
  padding: 0;
}

.btn-xs {
  font-size: 12px;
}

.btn-xlg {
  font-size: 25px;
  padding: 10px;
}

.btn-icon {
  width: 20px;
}
</style>
